export default __webpack_public_path__ + "static/media/cover.93ecffb2.jpeg";